import { UserRoles } from '@/enums';
import { AlfaApiLoanApplications } from '@/modules/alfa-api-loan-applications/types';

const access_roles = {
  [AlfaApiLoanApplications.Pages.ALFA_API_LOAN_APPLICATIONS]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.CREDIT_MANAGER,
  ],
};

export default access_roles;
